
import { IPaidItem, PayStatuses } from "@/models/payment";
import $API from "@/services";
import { splitDatetimeStringToString } from "@/utils/date-format";
import format from "@/utils/format";
import { computed, defineComponent, onMounted, reactive, ref, Ref } from "vue";

export default defineComponent({
  emits: ["updateCardInfo"],
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  setup(props, { emit }) {
    const state = reactive({
      id: props.id,
    });

    const paidItem: Ref<IPaidItem | null> = ref(null);

    const PaidDateTime = computed(() =>
      paidItem.value?.PaidDateTime
        ? `${splitDatetimeStringToString(
            paidItem.value.PaidDateTime.valueOf()
          )} 결제`
        : ""
    );

    const Title = computed(() =>
      paidItem.value?.PayStatus === PayStatuses.PAID
        ? "결제정보"
        : paidItem.value?.PayStatus === PayStatuses.REFUND_REQUEST
        ? "환불 예정 정보"
        : paidItem.value?.PayStatus === PayStatuses.REFUND
        ? "환불 정보"
        : ""
    );

    onMounted(async () => {
      try {
        paidItem.value = await $API.PaymentsService.getPaidItem(state.id);
       
        if (paidItem.value.OrderNumbwer) {
          emit("updateCardInfo", paidItem.value.OrderNumbwer);
        }
      } catch(ex) {
        console.warn(ex);
      }
     
     
    });
    return { paidItem, PaidDateTime, Title, format };
  },
});
